import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import UserProfileView from '../../../../components/user/UserProfileView';
import UserPageLayout from '../../../../components/user/UserPageLayout';
var UserProfile = function () {
    return (_jsx(UserPageLayout, { title: "Manage Your Profile", children: _jsx(UserProfileView, {}) }));
};
export default UserProfile;
